import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const messages = {
  invalidCode: 'Código inválido',
  invalidMsg:
    'Não há identificação válida para o romaneio. Para acessar o formulário de romaneio, você precisa usar um QRCode válido fornecido em uma PLP.',
  formTitle: 'Assinaturas de romaneio',
  formTitleSuccess: 'Romaneio assinado com sucesso',
  formMsgSuccess: 'Romaneio assinado pelo {{type}}',
  formMsg: 'Preencha o formulário com seus dados e assine.',
  code: 'Identificação do romaneio: {{code}}',
  driverName: 'Nome do motorista / agência parceira',
  licensePlate: 'Placa do veículo / número da agência parceira',
  driverSignature: 'Assinatura da transportadora ou agência parceira',
  signatureLocked: 'Preencha os campos anteriores para assinar.',
  dispatcherSignature: 'Assinatura do expedidor',
  sign: 'Assinar',
  erase: 'Apagar',
  requiredField: 'O campo {{-field}} é obrigatório',
  fieldMinLength: 'O campo {{-field}} precisa ter no mínimo {{number}} caracteres.',
  invalidField: 'O campo {{-field}} é inválido',
  sequentialField: 'O campo {{-field}} não pode ser uma sequência de letras ou números.',
  edgeSpacesField: 'O campo {{-field}} não pode ter espaços no início ou no final.',
  invalidCpf: 'CPF inválido',
  save: 'Salvar',
  saving: 'Salvando',
  fieldMaxLength: 'Máximo de {{number}} caracteres.',
  errorTitle: 'Erro!',
  successTitle: 'Sucesso!',
  successText: 'Os dados foram salvos com sucesso.',
  driverDocument: 'CPF do motorista/ recebedor da agência',
  shippingCompanySignature: 'Assinatura da transportadora',
  dispatcherName: 'Nome',
  formDisclaimer: 'Assim que assinado os pedidos deste romaneio mudarão para o status <strong>{{term}}</strong>.',
  driver: 'motorista',
  dispatcher: 'expedidor',
  collected: 'coletado',
  dispatched: 'despachado'
}

i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  resources: {
    'pt-BR': {
      translation: {
        ...messages
      }
    }
  }
})
